import BookingForm from "../../components/bookingForm/BookingForm"
import ContactExplain from "../../components/contact/ContactExplain"

const Contact = () => {
  return (
    <div className="view-contact">
      <div className="container-title">
        <div className="title">Contact</div>
      </div>
      <div className="container-contact-explain"> 
        <ContactExplain/>
      </div>
      <BookingForm/>
    </div>
  )
}

export default Contact
